
export class ProtocolClient<Event extends {type: string}, Command extends {type: string}> {
    protected readonly eventHandlers = new Map<Event['type'], (data: any) => void>()
    private readonly sendFromClientToServer: (command: Command) => void

    constructor(sendFromClientToServer: (command: Command) => void) {
        this.sendFromClientToServer = sendFromClientToServer
    }

    emitEvent<T extends Event['type']>(type: T, data: Omit<Extract<Event, {type: T}>, 'type'>) {
        this.eventHandlers.get(type)?.(data)
    }

    onEvent<T extends Event['type']>(eventType: T, handler: (data: Omit<Extract<Event, {type: T}>, 'type'>) => void) {
        if(this.eventHandlers.get(eventType) != undefined) throw new Error(`Event type ${eventType} already has a handler`)
        this.eventHandlers.set(eventType, handler)
    }

    removeListener<T extends Event['type']>(eventType: T) {
        this.eventHandlers.delete(eventType)
    }

    send<T extends Command['type']>(commandType: T, data: Omit<Extract<Command, {type: T}>, 'type'>) {
        this.sendFromClientToServer({type: commandType, ...data} as any)
    }
}
